import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { clearLastPosition, useConversationSessionStore } from '@/stores/conversation-session';

export default function useLastPosition(routeName: string, enable = true) {
  const positionRef = useRef<number>(0);
  const lastPosition = useConversationSessionStore((s) => s.lastPositions[routeName]);

  const setLastPosition = (position: number) => {
    positionRef.current = position;
  };
  const location = useLocation();

  useEffect(() => {
    if (!enable) return () => {};

    return () => {
      const previousPosition = useConversationSessionStore.getState().lastPositions[routeName];
      if (!previousPosition?.anchorId) {
        useConversationSessionStore
          .getState()
          .setLastPosition(routeName, { anchorId: positionRef.current, scrollTop: 0, ranges: [] });
      }
    };
  }, [location, routeName, enable]);

  return {
    lastPosition,
    setLastPosition,
    clearLastPosition: () => clearLastPosition(routeName),
  };
}
